/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tokenaccessforexternalsenabled4Inputs */

const de__field_tokenaccessforexternalsenabled4 = /** @type {(inputs: _Field_Tokenaccessforexternalsenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token-Anmeldung für externe Lehrkräfte aktiviert`)
};

/**

* @param {_Field_Tokenaccessforexternalsenabled4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_tokenaccessforexternalsenabled4 = /** @type {((inputs?: _Field_Tokenaccessforexternalsenabled4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tokenaccessforexternalsenabled4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_tokenaccessforexternalsenabled4(inputs)
});
export { _field_tokenaccessforexternalsenabled4 as "_field_tokenAccessForExternalsEnabled" }